import React, {Component} from 'react';
import $ from 'jquery';
import 'bootstrap-slider';

import './FJSliderContentHorizontal.less';

class FJSliderContentHorizontal extends Component {

    constructor(props) {
        super(props);
        this.sliderContent = React.createRef();
        this.slider = React.createRef();
    }

    componentDidMount() {
    this._UIInteraction();
        let sliderColor = this.props.sliderColor;
        if (sliderColor) {
            $(this.sliderContent.current).find('.slider-selection').css('cssText', 'background: none !important');
            $(this.sliderContent.current).find('.slider-track').css('cssText', 'background: linear-gradient(90deg,' + sliderColor.from + ' 0%,' + sliderColor.to + ' 100%) !important;');
        }
    }

    _isUpdateUI = false;

    updateSlider = (value) => {
        this._isUpdateUI = true;
        $(this.slider.current).slider('setValue', value);
        this._isUpdateUI = false;
    };
    resetSlider = () => {
        this._isUpdateUI = true;
        $(this.slider.current).slider('setValue', 0);
        this._isUpdateUI = false;
    };
    enableSlider = (toggle) => {
        if (toggle) {
            $(this.slider.current).slider('enable');
        } else {
            $(this.slider.current).slider('disable');
        }
    };
    _UIInteraction = () => {
        let $slider = $(this.slider.current).slider();
        $slider.on({
            "change": function (slideEvt) {
                if (!this._isUpdateUI) {
                    this.props.callback({type: "changed", value: slideEvt.value.newValue});
                }
            }.bind(this),
            "slideStart": function (slideEvt) {
                let sliderHandle = $(this.sliderContent.current).find('.slider-handle')[0];
                $(sliderHandle).addClass('slider-drag');
                $(this.sliderContent.current).addClass('active');
                if (!this._isUpdateUI)
                    this.props.callback({type: "slideStart", value: slideEvt.value});
            }.bind(this),
            "slideStop": function (slideEvt) {
                let sliderHandle = $(this.sliderContent.current).find('.slider-handle')[0];
                $(sliderHandle).removeClass('slider-drag');
                $(this.sliderContent.current).removeClass('active');
                if (!this._isUpdateUI)
                    this.props.callback({type: "slideStop", value: slideEvt.value});
            }.bind(this),
        });
    };

    render() {
        let {min, max, step, sliderID, value, hasMedian} = this.props;
        return (
            <div ref={this.sliderContent} className="c-toolbar__slider-content-horizontal">
                {
                    hasMedian ? <div className='c-median-scale'/> : null
                }
                <input ref={this.slider} data-slider-id={sliderID} type="text"
                       data-slider-min={min}
                       data-slider-max={max}
                       data-slider-step={step ? step : 1} data-slider-value={value}
                       data-slider-tooltip="hide"
                       />
            </div>
        );
    }
}

export default FJSliderContentHorizontal;
